<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Jenis Dokumen Organisasi"
        class="card-wrapper"
        >
        <form>
          <esign-filter-panel>
          <div style="height: 80px" class="form-input row">
            <div v-if="currentPeran==='A05'" class="col-4">
              <p class="label font-weight-bold mb-1">Organisasi (PAU/Fakultas/Sekolah)</p>
              <v-select
                :items="filteredOrganisasi"
                :item-text="item => item.nama"
                :item-value="item => item.id"
                placeholder="Pilih Organisasi"
                clearable
                dense
                outlined
                readonly
                disabled
                v-model="searchForm.idOrganisasi"
                @keydown.enter.prevent
              ></v-select>
            </div>
            <div v-if="currentPeran!=='A05'" class="col-4">
              <p class="label font-weight-bold mb-1">Organisasi (PAU/Fakultas/Sekolah)</p>
              <v-autocomplete
                no-data-text="Tidak ada data"
                :items="filteredOrganisasi"
                :item-text="item => item.nama"
                :item-value="item => item.id"
                placeholder="Pilih Organisasi"
                clearable
                dense
                outlined
                v-model="searchForm.idOrganisasi"
                @keydown.enter.prevent
              ></v-autocomplete>
            </div>
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Jenis Dokumen</p>
              <v-autocomplete
                no-data-text="Tidak ada data"
                :items="filteredJenisDokumens"
                :item-text="item => item.nama"
                :item-value="item => item.id"
                placeholder="Pilih Jenis Dokumen"
                clearable
                dense
                outlined
                v-model="searchForm.idJenisDokumen"
                @keydown.enter.prevent
            ></v-autocomplete>
            </div>
            <div class="col-2">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="searchJenisDokumenOrganisasi()"
              >
                Cari
              </v-btn>
            </div>
          </div>
          </esign-filter-panel>
          <br>
        </form>
        <v-card>
        <v-card-title>
            
            <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari di tabel"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn v-if="currentPeran ==='A01' || currentPeran ==='A05'"
                color="primary"
                class="mr-4"
            @click="addItem()">
              Tambah
            </v-btn>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            no-data-text="Tidak ada data"
            :search="search"
            :options.sync="tableOptions"
            :loading="isLoading"
            loading-text="Memuat data..."
            hide-default-footer
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            />
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn class="mx-1 mt-1 mb-1" x-small color="primary" dark @click="detailItem(item.Id)">
              <v-icon small class="mr-1"> mdi-eye </v-icon>
              Detail
            </v-btn>&nbsp
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01' || currentPeran ==='A05'" x-small color="orange" dark @click="editItem(item.Id)">
              <v-icon small class="mr-1"> mdi-pencil </v-icon>
              Ubah
            </v-btn>
          </template>
        </v-data-table>
        
        </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
            {{ snackbarText }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        </material-card>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";

export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["search", "searchForm", "tableOptions"],
  restoreAfterLoad: ["tableOptions"],
  data () {
    return {
      search: '',
      tableOptions: {},
      isLoading: false,
      totalData: 0,
      headers: [
        {
          text: 'Organisasi (PAU/Fakultas/Sekolah)',
          align: 'start',
          sortable: false,
          value: 'NamaOrganisasi',
        },
        { text: 'Jenis Dokumen', 
          sortable: false,
          value: 'NamaDokumen' 
        },
        { text: 'Tingkat Kerahasiaan', 
          sortable: false,
          value: 'TingkatKerahasiaan' 
        },
        { text: 'Workflow Persetujuan', 
          sortable: false,
          value: 'AlurPersetujuan' 
        },
        { text: 'Aksi',
          sortable: false,
          value: 'action',
          width: '200px',
        },
      ],
      items: [],
      jenisDokumens: [],
      organisasis:[],
      searchForm: {
        idJenisDokumen: -1,
        idOrganisasi: -1,
      },
      currentPeran: "",
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
    }
  },
  computed: {
      filteredJenisDokumens(){
          return this.jenisDokumens.filter(item => item.status)
      },
      filteredOrganisasi(){
          return this.organisasis.filter(item => item.status)
      }
  },
  created() {
    this.currentPeran = localStorage.getItem("currentPeran")
    if(this.currentPeran === 'A05') {
      this.searchForm.idOrganisasi = JSON.parse(localStorage.getItem("user")).pengguna.Organisasi.Id
      console.log("Pengguna peran A05, idOrganisasi: " + this.searchForm.idOrganisasi)
      console.log(JSON.parse(localStorage.getItem("user")).pengguna.Organisasi)
    }
    this.getData()
    this.getJenisDokumen()
    this.getOrganisasi()
    if (localStorage.getItem("success") != null) {
        this.showSnackbar("orange", localStorage.getItem("success"));
        localStorage.removeItem("success");
    }
  },
  methods: {
    getData() {
      this.isLoading = true;
      apiServer
          .get("/jenis_dokumen_organisasi/all", {
            params: {
              idOrganisasi: this.searchForm.idOrganisasi,
              idJenisDokumen: this.searchForm.idJenisDokumen
            }
          })
          .then(response => {
            console.log(response)
            this.items = response.data.data;
            this.totalData = response.data.total
            this.isLoading = false;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
          });
    },
    getJenisDokumen() {
      this.isLoading = true;
      apiServer
          .get("/jenis_dokumen/all")
          .then(response => {
            console.log(response)
            this.jenisDokumens = response.data.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
          });
    },
    getOrganisasi() {
      this.isLoading = true;
      apiServer
          .get("/organisasi/all")
          .then(response => {
            console.log(response)
            this.organisasis = response.data.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
          });
    },
    searchJenisDokumenOrganisasi() {
      if(!this.searchForm.idJenisDokumen) {
        this.searchForm.idJenisDokumen = -1
      }
      if(!this.searchForm.idOrganisasi) {
        this.searchForm.idOrganisasi = -1
      }
      this.getData()
    },
    addItem(){
      this.$router.push('/jenis-dokumen-organisasi/tambah');
    },
    editItem(id){
      this.$router.push('/jenis-dokumen-organisasi/ubah/' + id);
    },
    detailItem(id){
      this.$router.push('/jenis-dokumen-organisasi/detail/' + id);
    },
    showSnackbar(color, message) {
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    
  }
}
</script>